import styles from './style.module.scss';
import { Button, PageHeader } from 'components';
import { PlusOutlined } from '@ant-design/icons';
import { Col, Table, Row, Divider, Typography, Spin } from 'antd';
import { ExcelIcon } from 'icons';
import { Link } from 'react-router-dom';
import Filters from 'components/filters';
import { useTranslation } from 'react-i18next';
import useInvoicesCompareFootfallSales from '../useInvoicesCompareFootfallSales';
import BarChangeChart from '../../../charts/barChange';
import AlertMessage from '../../../components/alertMessage';

const MainPage = () => {
  const {
    title,
    data,
    columns,
    filters,
    format,
    loading,
    handleDownloadExcel,
    summary,
    searchParams,
    handleDownloadPdf,
    loadingPdf,
    errors,
  } = useInvoicesCompareFootfallSales();
  const { t } = useTranslation();

  return (
    <>
      <PageHeader title={t('Footfall & Sales').toUpperCase()}>
        <Row gutter={16}>
          <Col>
            <Button
              big
              type={'green'}
              iconMargin
              width={'138px'}
              icon={<ExcelIcon fill={'#fff'} />}
              onClick={handleDownloadExcel}
              loading={loading}
            >
              {t('Export')}
            </Button>
          </Col>
          <Col>
            <Button
              loading={loadingPdf}
              onClick={() => handleDownloadPdf(title)}
              big
              icon={<PlusOutlined />}
            >
              {t('Stampa')}
            </Button>
          </Col>
        </Row>
      </PageHeader>
      <div className={styles.container}>
        <Filters filters={filters} />
        <AlertMessage errors={errors} searchParams={searchParams} />
        <br />
        <Spin spinning={loading}>
          <Row className={styles.titleSection} justify={'center'}>
            <Col>
              <Typography.Title level={3}>{title}</Typography.Title>
            </Col>
          </Row>
          <Row>
            <Col xs={24} xxl={12}>
              <Table
                loading={loading}
                columns={columns}
                dataSource={data.tableData}
                pagination={{
                  pageSize: 10000,
                  position: ['bottomCenter'],
                  hideOnSinglePage: true,
                  showSizeChanger: false,
                }}
                bordered
                scroll={{ x: 700 }}
                summary={summary}
              />
            </Col>
            <Col xs={24} xxl={12}>
              <BarChangeChart
                keys={['Footfall', 'Net Sales']}
                data={data}
                format={format}
                lineItemWidth={150}
                translateX={200}
              />
            </Col>
          </Row>
        </Spin>
      </div>
    </>
  );
};

export default MainPage;
